const PastSpanishQuestions = {
  "ES_Opinion": {
    "2024": [
      "Hay que celebrar nuestra cultura.",
      "Vivir en otro país puede ser difícil.",
      "El deporte es importante para todos"
    ],
    "2023": [
      "No hay nada tan importante como la familia.",
      "Ser estudiante en Irlanda es muy caro.",
      "Hoy día los jóvenes tienen una vida muy fácil."
    ],
    "2022": [
      "El trabajo no es lo más importante.",
      "Los cambios son positivos.",
      "Todo es posible con la tecnología."
    ],
    "2021": [
      "El mundo necesita voluntarios.",
      "Es importante ayudar a la gente.",
      "Ser voluntario es una experiencia fantástica."
    ],
    "2020": [
      "Compramos demasiada ropa.",
      "Los jóvenes pueden cambiar el mundo"
    ],
    "2019": [
      "Los animales son nuestra responsabilidad",
      "Los zoos son importantes"
    ],
    "2018": [
      "Es importante viajar",
      "La vida es una aventura."
    ]
  },
  "ES_LetterEmail": {
    "2024": [
      "You read an article in a Spanish newspaper promoting Ireland as a holiday destination.\nYou decide to write a LETTER / EMAIL in Spanish to the editor of the newspaper.\n(You may loosely base your letter/email on the points mentioned below, either agreeing or disagreeing with them. You should make five relevant points out of the eight below and each of these points should be expanded and developed.)\n* Ireland is an expensive country to visit.\n* There are lots of historic sites to see.\n* Irish music and traditions are famous worldwide.\n* The climate is not extreme.\n* There are many flights from Spain to Ireland.\n* Ireland is a small country, so it is easy to travel around.\n* Ireland produces good food.\n* Irish people are very friendly."
    ],
    "2023": [
      "A newspaper article states that Spanish people should spend time in Ireland to improve their English.\nYou decide to write a LETTER / EMAIL in Spanish to the editor of the newspaper.\n(You may loosely base your letter/email on the points mentioned below, either agreeing or disagreeing with them. You should make five relevant points out of the eight below and each of these points should be expanded and developed.)\n* Spanish people don't need a visa to live in Ireland.\n* There are excellent language schools all over the country.\n* Spanish people can work part-time to pay for their studies.\n* Irish people are very friendly and the accent is easy to understand.\n* There are cheap flights between Spanish and Irish airports.\n* The cost of living is expensive.\n* The scenery is amazing, especially along the coasts.\n* Ireland is great for people who like music and culture."
    ],
    "2022": [
      "You read an article about young people not protecting the environment.\nYou decide to write a LETTER / EMAIL in Spanish to the editor of the newspaper.\n(You may loosely base your letter/email on the points mentioned below, either agreeing or disagreeing with them. You should make five relevant points out of the eight below, and each of these points should be expanded and developed.)\n* Young people are not responsible for the problems of the planet.\n* Young people know they need to protect the environment.\n* Young people can make a difference.\n* Teenagers do not have time to worry about environmental issues.\n* The internet is a way of informing people about the environment.\n* Many animal species are in danger of extinction.\n* We should invest more in renewable energy.\n* We all can do more to conserve water."
    ],
    "2021": [
      "You read an article saying that young people are addicted to their mobile phones.\nWrite a letter/email in Spanish to the editor of the newspaper.\n(You may loosely base your letter/email on the points mentioned below, either agreeing or disagreeing with them. You should make five relevant points out of the eight below and each of these points should be expanded and developed.)\n* Mobile phones can be useful for education.\n* Schools should have rules about the use of mobile phones.\n* Addiction to mobile phones can be a problem.\n* Some people spend too much time on their mobile phones.\n* Mobile phones can be beneficial for language students.\n* Mobile phones are part of life nowadays.\n* Communication with family and friends is easier with mobile phones.\n* Mobile phones are vital in emergencies."
    ],
    "2020": [
      "A recent newspaper article states that Spanish food is very popular with all nationalities.\nYou decide to write a LETTER / EMAIL in Spanish to the editor of the newspaper.\n(You may loosely base your letter/email on the points mentioned below, either agreeing or disagreeing with all or some of them. You should make five relevant points, and each of these points should be expanded and developed.)\n* Food is an important part of a country's culture.\n* Spanish food is very popular in Ireland.\n* The Spanish diet is very varied and healthy.\n* Tourists should try traditional dishes like paella when in Spain.\n* Eating in Spanish restaurants is an opportunity to meet Spanish people."
    ],
    "2019": [
      "An article in a newspaper says that learning Spanish is not really necessary anymore as most people speak English.\nYou decide to write a LETTER / EMAIL in SPANISH to the editor of the newspaper.\n(You may loosely base your letter/email on the points mentioned below, either agreeing or disagreeing with all or some of them. You should make five relevant points and each of these points should be expanded and developed.)\n* More than four hundred and thirty million people speak Spanish worldwide.\n* Very few people speak English in South America.\n* If you speak Spanish, travel is easier.\n* Many jobs require Spanish.\n* Schools should encourage students to learn foreign languages."
    ],
    "2018": [
      "An article in a Spanish newspaper says that taking a 'Gap Year' when you finish school is a waste of time.\nYou decide to write a LETTER / EMAIL in SPANISH to the editor of the newspaper.\n(You may loosely base your letter/email on the points mentioned below, either agreeing or disagreeing with all or some of them. You should make five relevant points and each of these points should be expanded and developed.)\n* Travelling around other countries is a positive experience.\n* It is an opportunity to learn another language.\n* Young people can earn money.\n* Relevant work experience can be useful.\n* You can have lots of fun on a 'Gap Year'."
    ]
  },
  "ES_Diary": {
    "2024": [
      "You have spent the year studying in Salamanca, and you are returning home.\nWrite a diary entry in Spanish mentioning any four of the following points:\n* Say that the experience was amazing. Explain why.\n* Mention two things you like about living in Spain.\n* Describe a day trip you took with your brother last month.\n* Mention how you plan to keep improving your Spanish.\n* Say how you are going to spend your last weekend in Spain."
    ],
    "2023": [
      "You have just spent a month travelling in Spain on your own.\nWrite a diary entry in Spanish mentioning any four of the following points:\n* Say that you've had a great time and explain why.\n* Mention one advantage of travelling alone.\n* Describe an interesting Spanish person that you met.\n* Explain why you don't like the hostel where you are staying.\n* Say how you plan to spend your first day back in Ireland."
    ],
    "2022": [
      "You are on holidays in Barcelona with your family and your Spanish friend Sara.\nWrite a diary entry in Spanish mentioning any four of the following points:\n* Explain how you and Sara met.\n* Describe the apartment where you are staying.\n* Talk about a tourist attraction that you visited.\n* Your sister is not enjoying the holiday. Explain why.\n* Say what you are going to do this evening."
    ],
    "2021": [
      "You are doing a Spanish course in Valencia.\nWrite a diary entry in Spanish mentioning any four of the following points:\n* Say what you think about Valencia.\n* Give one detail about where you are staying.\n* Describe one of your teachers.\n* Give one detail about an excursion you went on.\n* Mention what your plans are for the rest of the summer."
    ],
    "2020": [
      "You are on a school exchange in Valladolid.\nWrite a diary entry in Spanish mentioning all of the following points:\n* Say how you feel after your first day in the school.\n* Describe two things you did at school.\n* Mention one problem you had.\n* Explain how the school is different from your school."
    ],
    "2019": [
      "You are in Almería. Your flight home has been cancelled.\nWrite a diary entry in SPANISH including the following details:\n* Say that your parents are very angry, explain why.\n* You feel great because it's the best hotel you have stayed in.\n* There is a fabulous pool, free Wi-Fi, and you can be online all day (and night).\n* Say what your plans are for the remainder of your stay."
    ],
    "2018": [
      "You are working in Salamanca for the summer.\nWrite a diary entry in SPANISH mentioning all of the following points:\n* Say that you have started your new job and say what it is like.\n* Describe two things you have to do at work.\n* Mention one problem at work.\n* Explain what you will do with the money you earn."
    ]
  },
  "ES_Note": {
    "2024": [
      "You are working in a restaurant in Mijas, you are about to take a break.\nLeave a note in Spanish for the manager, Elena. Include four of the following points:\n* Say that the chef just rang to say that he is sick.\n* Tell her that you could help in the kitchen.\n* You have cleaned the tables and the bathroom.\n* Mention that you are really happy today. Explain why.\n* Ask for a day off next week to visit your cousin in Estepona."
    ],
    "2023": [
      "You are staying in Bilbao with your friend Iker.\nLeave a note in Spanish for Iker including any four of the following points:\n* Say you got up early to go for a swim in the sea.\n* Tell him that the kitchen is dirty but you'll clean it later.\n* Say that you have both been invited to a party on Friday night.\n* Say that you will buy drinks and food tomorrow for the party.\n* Ask him if he'd like to visit Pamplona with you on Saturday."
    ],
    "2022": [
      "You have just started working in a youth hostel in Toledo.\nLeave a note in Spanish for the manager, Luis. Include four of the following points:\n* Say that you have cleaned the bedrooms.\n* Tell him that the WIFI is not working.\n* You are going to town now to buy summer clothes.\n* Mention that the group from Cork arrived this afternoon.\n* Say that you will start work tomorrow morning at 7 am."
    ],
    "2021": [
      "You are going to a concert in Valencia.\nLeave a note in Spanish for Carmen including any four of the following points:\n* Say you are going to the concert on the beach with some friends.\n* Mention that your favourite group is going to play.\n* You are going to take the bus with Juan.\n* Say you will be home before midnight.\n* You will send her some photos of the concert."
    ],
    "2020": [
      "You are on a school exchange in Valladolid, staying with your Spanish friend Paco.\nLeave a note in Spanish for your friend including all of the following points:\n* Say that his friend David rang this morning.\n* Tell him that the visit to the museum is next Wednesday.\n* The bus will leave the school at ten o'clock sharp.\n* There is a café in the museum where we will have lunch."
    ],
    "2019": [
      "You have arranged to go to the cinema with your Spanish friend Pilar.\nLeave a NOTE in Spanish inviting Fernando to come along. Include all of the following points:\n* Say that your friend Pilar has asked you to go to the cinema.\n* Ask Fernando if he would like to come too.\n* You have never seen a film in Spanish before.\n* You hope that it will be easy to understand."
    ],
    "2018": [
      "You are staying in Granada with your Spanish friend Paco.\nLeave a note in Spanish for your friend including all of the following points:\n* Say that your foot is very sore.\n* Tell him that you are going to see the doctor around one o'clock.\n* Say that you can't walk so you are going to get a taxi.\n* You will be back at the apartment before dinner."
    ]
  },
  "ES_Oral": {"Family and Personal Background":[

    "¿Cómo te llamas?",
    
    "¿Cuántos años tienes?",
    
    "Háblame de tu familia.",
    
    "¿Cuántas personas hay en tu familia?",
    
    "¿Tienes hermanos?",
    
    "¿Te llevas bien con tu familia (o con tus hermanos)?",
    
    "¿En qué trabajan tus padres?",
    ],
    
    "Home and Local Area":[
    
    "¿Dónde vives?",
    
    "¿Cómo es tu casa?",
    
    "¿Cómo es tu barrio?",
    
    "¿Te gusta tu barrio?",
    
    "¿Hay mucho que hacer?",
    ],
    
    "School and Education":[
    
    "¿Cómo se llama tu colegio?",
    
    "¿Cómo es tu colegio?",
    
    "¿A qué hora empiezan las clases?",
    
    "¿A qué hora terminan las clases?",
    
    "¿Te gusta el colegio?",
    
    "¿Qué instalaciones hay en tu colegio?",
    
    "¿Cuántas asignaturas estudias este año?",
    
    "¿Cuál es tu asignatura preferida?",
    
    "¿Cuál es la asignatura que más/menos te gusta?",
    
    "¿Tenéis que llevar uniforme en el instituto?",
    
    "¿Qué opinas de la Selectividad / del bachillerato?",
    ],
    
    "Hobbies and Free Time":[
    
    "¿Qué haces en tu tiempo libre?",
    
    "¿Cuáles son tus pasatiempos?",
    
    "¿Practicas algún deporte?",
    
    "¿Cuál es tu equipo preferido?",
    
    "¿Qué haces los fines de semana?",
    
    "¿Te gusta la música?",
    
    "¿Qué tipo de música prefieres?",
    
    "¿Tocas algún instrumento musical?",
    ],
    
    "Work and Money":[
    
    "¿Tienes un trabajo a tiempo parcial?",
    
    "¿Tienes trabajo? ¿Dónde trabajas?",
    
    "¿Tus padres te dan dinero (paga)?",
    
    "¿En qué gastas tu dinero?",
    ],
    
    "Daily Routine":[
    
    "¿A qué hora te despiertas normalmente?",
    
    "¿Qué tomas para el desayuno?",
    ],
    
    "Food and Eating Out":[
    
    "¿Qué tipo de comida prefieres?",
    
    "¿Has probado la comida española?",
    
    "¿Te gusta la comida rápida?",
    ],
    
    "Future Plans":[
    
    "¿Qué vas a hacer después de la Selectividad / del bachillerato?",
    
    "¿Qué vas a hacer este verano, después de los exámenes?",
    
    "¿Qué piensas hacer el año que viene?",
    
    "¿Qué te gustaría estudiar en la universidad?",
    
    "¿En qué te gustaría trabajar en el futuro?",
    
    "¿Cuántos puntos necesitas para entrar en esa carrera / curso?",
    
    ]
    }
};

export default PastSpanishQuestions; 